export interface PageSlotElementRefillCandidate {
  formId?: string | number | null
  pageDataSlot?: string | number | null
}

/**
 * Refill UI from pagesData only for elements owned by the target tab slot.
 * Avoids cross-tab refill when field names collide 
 */
export function pageSlotElementRefillMatch(
  element: PageSlotElementRefillCandidate | null | undefined,
  pageSlotId: string,
): boolean {
  const pageSlot = String(pageSlotId ?? '').trim()
  if (!pageSlot || !element) return false

  const elPageSlot = String(element.pageDataSlot ?? '').trim()
  if (elPageSlot && elPageSlot === pageSlot) return true

  const elFormId = String(element.formId ?? '').trim()
  return Boolean(elFormId && elFormId === pageSlot)
}

/**
 * Collect element registry keys that should receive refill for a page slot.
 */
export function pageSlotElementRefillKeys(
  elementsByKey: Record<string, PageSlotElementRefillCandidate>,
  pageSlotId: string,
): string[] {
  const pageSlot = String(pageSlotId ?? '').trim()
  if (!pageSlot) return []

  return Object.entries(elementsByKey)
    .filter(([, element]) => pageSlotElementRefillMatch(element, pageSlot))
    .map(([key]) => key)
}
